import {
  TagCategoryFormDefaultValues,
  TagCategoryFormProps,
  TagCategoryFormRawValues,
  TagCategoryFormType,
  TagCategoryFormValues
} from "./TagCategoryForm";
import {useTranslation} from "react-i18next";
import {createFormContext} from "@mantine/form";
import {TagCategoryEntity,} from "@ots-frontend/ots-data";

export const toFormDefaultsFromTagCategory = (def: TagCategoryEntity | undefined): Partial<TagCategoryFormValues> => {
  return {
    label: def?.label,
    description: def?.description,
    doNotUse: def?.doNotUse,
  };
};

const getInitialValues = (defaultValues: TagCategoryFormDefaultValues | undefined): TagCategoryFormRawValues => {
  return {
    label: defaultValues?.label,
    description: defaultValues?.description,
    doNotUse: defaultValues?.doNotUse,
  }
}

export const [TagCategoryFormProvider, useTagCategoryFormContext, useSharedTagCategoryForm] = createFormContext<TagCategoryFormRawValues>();

export type UseTagCategoryFormProps = Pick<TagCategoryFormProps, 'defaultValues'> & {}

export function useTagCategoryForm(props: UseTagCategoryFormProps): TagCategoryFormType {
  const {
    defaultValues
  } = props

  const {t} = useTranslation(["common"])

  const form = useSharedTagCategoryForm({
    initialValues: getInitialValues({
      ...defaultValues,
    }),
    validate: {
      label: (value) => value ? undefined : t("common.validation.required", "Required"),
    },
  })

  return form
}
